import type { DancerExperience } from './types';

/**
 * The single partition predicate splitting experience credits into the two
 * profile sections:
 *
 *   AWARDS      = type IN ('award','competition')  OR  a non-empty placement
 *   ENGAGEMENTS = everything else
 *
 * Defined ONCE here so the Experience timeline (`!isAwardExperience`) and the
 * Awards section (`isAwardExperience`) can never drift apart — the WIP
 * falsifier ("awards leak into engagements or vice-versa") is structurally
 * impossible while both consume this helper.
 */
export function isAwardExperience(exp: DancerExperience): boolean {
  return (
    exp.type === 'award' ||
    exp.type === 'competition' ||
    !!exp.placement?.trim()
  );
}
